
import { Component, Vue } from "vue-property-decorator";
import { Action, Mutation, State } from "vuex-class";
import { page } from 'vue-analytics'
import Entry from "@/models/entry";
import FlatLoader from "@/components/FlatLoader.vue";
import AboutHeader from "@/components/AboutHeader.vue";

const namespace = "PostsModule";

@Component({
  components: {
    FlatLoader,
    AboutHeader
  },
  metaInfo: {
    title: 'Home',
    titleTemplate: 'Pau Roselló | %s'
  }
})

export default class Posts extends Vue{
  @Action('fetchData', { namespace }) private fetchData!: () => any;
  @State('entries', { namespace }) private entries!: () => Entry[];
  @State('loading', { namespace }) private loading!: () => boolean;
  @Mutation private setPreviousPage!: (name: string) => any;
  @Mutation private setCurrentPage!: (name: string) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
  }

  private async created(){
    await this.fetchData();
  }

  private entryImage(){
    return "background-color: #fff";
  }

};
